import React, { useState } from "react";
import { Chip } from "@mui/material";
export default function Chips({ label, activeTab, index, handleClick }) {
  return (
    <Chip
      onClick={() => handleClick(index)}
      label={label}
      // className="__siki_chip"
      sx={{
        color: activeTab === index ? "var(--text-primary, #000000)" : "#999999",
        cursor: activeTab === index ? "default" : "pointer",
        "&:hover":
          activeTab === index
            ? {}
            : {
                backgroundColor: "var(--background-color, #000000) !important",
                borderColor: "var(--text-primary, #ffffff) !important",
                color: "var(--text-primary, #ffffff)",
              },
      }}
      color={activeTab === index ? "primary" : "default"}
      variant={activeTab === index ? "filled" : "outlined"}
    />
  );
}
